/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=eaaa74f0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=eaaa74f0&lang=css"

import exportComponent from "/home/nightdays/app/code/vue/nb-recharge/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__